import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { RevelationMiniEntity } from '../../domain/entities/RevelationMiniEntity'
import type { CouponRevelationListedAdminDto } from '@/backend/market'

export class RevelationMiniModel extends RevelationMiniEntity {
  constructor(dataDto: CouponRevelationListedAdminDto) {
    super()
    mapEntityProperties<RevelationMiniEntity>(this, dataDto)
  }
}
